import '~/js/modules/stickyNav';
import '~/js/modules/section-hero';
import RoomAccommodations from '~/js/components/accommodations/MainPanel';

const $main = $('html, body');
const scrollToBtn = document.querySelector('[data-scroll-to]');
const scrollToElement = document.querySelector(`.${scrollToBtn.dataset.scrollTo}`);

scrollToBtn.addEventListener('click', () => {
  $main.animate({
    scrollTop: scrollToElement.getBoundingClientRect().top + window.pageYOffset - 120
  }, 400);
});
const villageCode = 'sbv';
const filteredRooms = ['P2', 'HG1', 'G1'];

ReactDOM.render(
  <RoomAccommodations
    resortCode="btc"
    villageCode={ villageCode }
    accomodationTitle="-"
    filterRoomsArray= {filteredRooms}
  />,
  document.querySelector('#root')
);
